import "@fontsource/poppins";
import { ChakraProvider } from "@chakra-ui/react";
import { theme } from "./theme";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./routes";
import { SessionChecker } from "./components";

function App() {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <SessionChecker />
        <AppRoutes />
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
